import { Injectable, Inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import { DOCUMENT } from '@angular/common';
import { RequestPayLoadFormat, CommonServiceLayerService } from './services/common-service-layer.service';
import { SharedService } from './shared/shared.service';
import { GlobalVariablesService } from './layout/global-variables.service';
import { LayoutService } from './layout/layout.service';
import { SessionhandlerService } from './services/sessionhandler.service';

@Injectable({
  providedIn: 'root'
})
export class AppService {
  constructor(
    @Inject(DOCUMENT) private doc: HTMLDocument,
    public http: CommonServiceLayerService,
    public sharedService: SharedService,
    public globalVariableServices: GlobalVariablesService,
    public layoutService: LayoutService,
    public storage: SessionhandlerService
  ) {
  }

  public DOMAIN_MAPPING: DomainDetails;

  public constants: any = {};

  public CLIENT_TYPE = environment.CLIENT_TYPE;


  public DOMAIN_DETAILS(): DomainDetails {
    return this.DOMAIN_MAPPING;
  }
  public setDomainMapping(data) {
    this.DOMAIN_MAPPING = data;
    this.onResponse();
  }
  onResponse() {
    this.setTabDetails();
    if (this.DOMAIN_DETAILS().staticFilters) {
      this.globalVariableServices.FILTER_FORM_MAPPING.staticFields = this.DOMAIN_DETAILS().staticFilters;
    }
    if (this.DOMAIN_DETAILS().staticFiltersDuplicates) {
      this.layoutService.duplicates = this.DOMAIN_DETAILS().staticFiltersDuplicates;
    }
  }
  setTabDetails() {
    this.doc.getElementById('tab-title-icon').setAttribute('href', 'assets/images/' + this.DOMAIN_MAPPING.titleLogo);
    this.doc.getElementById('tab-title-text').innerHTML = this.DOMAIN_MAPPING.tabTitle;
  }
  setConstants(data) {
    this.constants = data;
  }
  async loadNavHeader() {
    const payLoad = {};
    try {
      const request: RequestPayLoadFormat = {
        api: 'navHeader', // navHeader
        method: 'postText',
        loader: true,
        type: 'API',
        hideErrorMessage: false,
        payLoad
      };
      const response = await this.http.API_REQUEST(request).toPromise();
      if (response && response.status) {
        this.storage.api.local.save('navBar_Length', response.data.Menus.length);
        return response.data.Menus;
      } else {
        this.sharedService.serviceErrorMessage(response.message);
        return [];
      }
    } catch (error) {
      console.log(error);
    }
  }
}
export interface DomainDetails {
  landingPage: string;
  vendorHeader: boolean;
  logo: string;
  vendorLogo: string;
  tabTitle: string;
  tabIcon: string;
  clientLogo: string;
  titleLogo: string;
  isYIL: boolean;
  isBPCL: boolean;
  footerLogo: string;
  aqiDashboardMapLayers?: boolean;
  exceedanceMarquee?: boolean;
  siteTitle: string;
  userRoleTabKeys?: Array<string>;
  staticFilters?: any;
  mqttDashboard?: boolean;
  staticFiltersDuplicates?: any;
  defaultUserSetup?: boolean;
  footerText?: string;
  labelType?: string;
  selectAllForFilterModal?: boolean;
  electron?: boolean;
  geoJSON?: string;
  navHeaderLogo?: string;
  activeDirectory?: boolean;
  parameterView?: boolean;
}
